import { useDispatch, useSelector } from "react-redux";
import { Link as NavLink } from "react-router-dom";
import { checkToken, FILE_PATH_URI } from "../../utils/helper";
import { useState } from "react";
import { clearFcmTokenOnBackend } from "../../services/firebase.service";

import {
  Avatar,
  Box,
  Button,
  Divider,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";

function MemberMenu({ sidebarDeActive }) {
  const dispatch = useDispatch();
  const [anchor, setAnchor] = useState(null);
  const { member, specialist } = useSelector((state) => state.authSlice);
  const open = Boolean(anchor);
  const handleCloseMenu = () => {
    setAnchor(null);
  };

  const handleClickMenu = (event) => {
    setAnchor(event.currentTarget);
  };

  // Handle logout
  const handleLogout = async () => {
    try {
      await clearFcmTokenOnBackend();
    } catch (e) {
      console.error(e);
    }
    dispatch({ type: "Logout", payload: {} });
  };

  return checkToken(dispatch)?.valid ? (
    <>
      <Box
        sx={{
          display: "flex",
          
        }}
      >
        <IconButton
          sx={{
            p: "2px",
            border: "2px solid",
            borderColor: "primary.main",
          }}
          size="small"
          onClick={handleClickMenu}
        >
          <Avatar
            sx={{
              width: "35px",
              height: "35px",
            }}
            src={
              member?.image ||
              (specialist?.profile?.profilePhoto
                ? `${FILE_PATH_URI}${specialist.profile.profilePhoto}`
                : (specialist?.specialist?.image || specialist?.image) !== `${FILE_PATH_URI}undefined`
                  ? (specialist?.specialist?.image || specialist?.image)
                  : "")
            }
          />
        </IconButton>
        <Box
          sx={{
            display: {
              xs: "block",
              sm: "block",
              md: "block",
              xl: "none",
            },
          }}
          pl={2}
        >
          <Typography
            sx={{
              width: "100%",
              lineHeight: "1.2",
              display: "block",
              fontWeight: "400",
              color: "other.color1",
              textTransform: "capitalize",
            }}
            component="span"
          >
            {member?.fullName || specialist?.specialist?.fullName || specialist?.fullName}
          </Typography>
          <Typography
            component="span"
            sx={{
              width: "100%",
              lineHeight: "1",
              display: "block",
              fontSize: "12px",
              fontWeight: "400",
              color: "other.color1",
            }}
          >
            {member?.username ? "@" : ""}
            {specialist?.specialist?.username || specialist?.username || "Specialist"}
          </Typography>
        </Box>
      </Box>

      <Menu
        sx={{
          mt: 0.5,
          ".MuiPaper-root": {
            borderRadius: "8px",
            border: "1px solid",
            borderColor: "divider",
            boxShadow: "0px 0px 10px 0px #0000000a",
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={open}
        anchorEl={anchor}
        onClose={handleCloseMenu}
      >
        <MenuItem
          sx={{
            px: 1,
            py: "0",
            minWidth: "180px",
          }}
          disableRipple
        >
          <Box
            sx={{
              gap: 1,
              display: "flex",
              flexWrap: "nowrap",
              alignItems: "center",
            }}
          >
            <Avatar
              sx={{
                width: "35px",
                height: "35px",
              }}
              src={
                member?.image ||
                (specialist?.profile?.profilePhoto
                  ? `${FILE_PATH_URI}/${specialist.profile.profilePhoto}`
                  : (specialist?.specialist?.image || specialist?.image) !==
                    "http://localhost:5000/src/uploads/undefined"
                    ? (specialist?.specialist?.image || specialist?.image)
                    : "")
              }
            />

            <Box>
              <Typography
                sx={{
                  width: "100%",
                  lineHeight: "1.2",
                  display: "block",
                  fontWeight: "400",
                  color: "other.colo1",
                  textTransform: "capitalize",
                }}
                component="span"
              >
                {member?.fullName || specialist?.specialist?.fullName || specialist?.fullName}
              </Typography>
              <Typography
                component="span"
                sx={{
                  width: "100%",
                  lineHeight: "1",
                  display: "block",
                  fontSize: "12px",
                  fontWeight: "400",
                  color: "other.colo1",
                }}
              >
                {member?.username ? "@" : ""}
                {member?.username || "Specialist"}
              </Typography>
            </Box>
          </Box>
        </MenuItem>
        <Divider />

        <MenuItem
          sx={{
            px: 1,
            minWidth: "180px",
            justifyContent: "start",
          }}
          disableRipple
          onClick={handleCloseMenu}
        >
          <Link
            sx={{
              width: "100%",
              color: "other.color1",
              fontSize: {},
            }}
            underline="none"
            component={NavLink}
            to={`/${member?.userRole ? member.userRole : "specialist"}/profile`}
          >
            Dashboard
          </Link>
        </MenuItem>
        <MenuItem
          sx={{
            px: 1,
            minWidth: "180px",
            justifyContent: "start",
          }}
          disableRipple
          onClick={handleCloseMenu}
        >
          <Link
            sx={{
              width: "100%",
              textAlign: "start",
              color: "other.color1",
            }}
            underline="none"
            component="button"
            onClick={handleLogout}
          >
            Logout
          </Link>
        </MenuItem>
      </Menu>
    </>
  ) : (
    <Stack spacing={{ xs: "5px", xxl: 2 }} direction="row">
      <Button
        sx={{
          fontWeight: "400",
          letterSpacing: "0",
          justifyContent: "center",
          minWidth: { xs: "95px", xxl: "110px" },
        }}
        to="/login"
        color="primary"
        variant="contained"
        LinkComponent={NavLink}
        onClick={sidebarDeActive}
      >
        Log In
      </Button>
      <Button
        sx={{
          letterSpacing: "0",
          fontWeight: "400",
          justifyContent: "center",
          minWidth: { xs: "95px", xxl: "110px" },
        }}
        to="/register"
        color="secondary"
        variant="contained"
        onClick={sidebarDeActive}
        LinkComponent={NavLink}
      >
        Register
      </Button>
    </Stack>
  );
}

export default MemberMenu;
